/** Maximum unique destinations the link-inspection lane may request. */
export const EMAIL_AUDIT_MAX_LINKS = 100
